<div class="radio-container" [ngStyle]="small && {'margin-top': '0', 'height':'unset'}" (click)="selectBox()">
  <div class="content">
    <div class="radio-icon {{ selected ? 'selected' : '' }}">
      <div class="circle"></div>
    </div>
    <div class="label">{{ title }}</div>
  </div>
</div>
